export default {
  getAllData: state => state?.data,
  getProjectById: state => id => state?.data?.find(item => item.gantt_id === id) || null,
};
